/* istanbul ignore file */
import { fireLinkTag } from './tagManager';

export function tagShopMoreLinkClick() {
  fireLinkTag({
    event_name: 'pdp sales link click',
    link_name: 'pdp sales link click',
  });
}

/**
 * @param {string} promoCode
 * @param {string} priceTypeText
 * @returns {void}
 */
export function tagShopMoreToastLinkClick(promoCode, priceTypeText) {
  const promoton = promoCode || priceTypeText;
  fireLinkTag({
    event_name: `pdp toast link:${promoton}`,
    link_name: `pdp toast link:${promoton}`,
  });
}

export default {
  tagShopMoreLinkClick,
  tagShopMoreToastLinkClick,
};
